export const EMPTY_COUPON_PAGE_TEST_IDS = {
    CONTAINER: "empty-coupon-page-container",
    HEADING: "empty-coupon-page-heading",
    DESCRIPTION: "empty-coupon-page-description",
    CTA_BUTTON: "empty-coupon-page-cta-button",
};
